export var localizationActions = {
    SET_LOCALE: "SET_LOCALE"
};
export default localizationActions;

//# sourceMappingURL=localizationActionstypes.js.map